import styled from "styled-components";

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 20px 0;
  .pagination {
    margin: 0;
    li {
      &:first-child a,
      &:last-child a {
        border: none;
        margin: 0;
        padding-left: 0;
        padding-right: 0;
        width: 30px;
        &:hover {
          background: none;
        }
      }
      a {
        margin: 0 8px;
        width: 28px;
        height: 28px;
        line-height: 28px;
        padding: 0;
        text-align: center;
        font-size: 12px;
        border-radius: 50%;
        border: none;
        color: #33333a;
        font-family: "latobold";
        margin: 0;
        background-color: transparent;
        &:focus {
          box-shadow: none;
        }
      }
    }
    .active a {
      background-color: #dcedf7;
      color: #000;
    }
    .disabled a {
      opacity: 0.3;
    }
  }
`;
